/* eslint-disable @typescript-eslint/strict-boolean-expressions */
/* eslint-disable @typescript-eslint/restrict-template-expressions */
import ArrowBackRoundedIcon from '@mui/icons-material/ArrowBackRounded'
import { Box, IconButton, Typography } from '@mui/material'
import { useLeafletContext } from '@react-leaflet/core'
import { Dispatch } from '@reduxjs/toolkit'
import axios from 'axios'
import L, { Map } from 'leaflet'
import _ from 'lodash'
import polyline from 'polyline'
import React, { MutableRefObject, Ref, useEffect, useMemo, useRef, useState } from 'react'
import gregorian from 'react-date-object/calendars/gregorian'
import persian from 'react-date-object/calendars/persian'
import gregorian_en from 'react-date-object/locales/gregorian_en'
import persian_fa from 'react-date-object/locales/persian_fa'
import {
  MapContainer,
  TileLayer,
  Popup,
  Marker,
  Circle,
  Polyline,
  useMapEvents,
  useMapEvent,
  useMap,
} from 'react-leaflet'
import { DateObject } from 'react-multi-date-picker'
import { useDispatch, useSelector } from 'react-redux'
import { useLocation, useNavigate } from 'react-router-dom'
import swal from 'sweetalert'

import imageIcon from '../../assests/icons/circle.png'
import imageIcon1 from '../../assests/icons/flag1.png'
import Button from '../../shared/Button'
import {
  getLatiTude,
  getLongiTude,
  getPositionList,
  getPositionLists,
  resetPositionList,
  setTripList,
} from '../../store/devices'
// تابع تبدیل تاریخ شمسی به میلادی
const shamsi = (time: string) => {
  if (time === undefined) return
  const time1 = time
  var replaceTime = _.replace(time1, 'T', ' ')
  replaceTime = _.replace(replaceTime, 'Z', ' ')

  const date = new DateObject({
    date: replaceTime,
    format: 'YYYY/MM/DD HH:mm:ss',
  })
  date.convert(persian, persian_fa)
  date.add(3, 'hour')
  date.add(30, 'minute')
  return date.format('YYYY/MM/DD')
}
const time = (time: string) => {
  if (time === undefined) return
  const time1 = time
  var replaceTime = _.replace(time1, 'T', ' ')
  replaceTime = _.replace(replaceTime, 'Z', ' ')

  const date = new DateObject({
    date: replaceTime,
    format: 'YYYY/MM/DD HH:mm:ss',
  })
  date.convert(persian, persian_fa)
  date.add(3, 'hour')
  date.add(30, 'minute')
  return date.format('HH:mm:ss')
}
const icon = L.icon({
  iconUrl: imageIcon,
  iconSize: [7, 7],
})
const flag = L.icon({
  iconUrl: imageIcon1,
  iconSize: [50, 50],
})

const LocationTrip = () => {
  // const a: any = polyline.decode(
  //   'wbeyEki`xHxAvA~@mB}BqBs@pAwAq@yAsAT}BuBdCuDzAkiAsF_Dic@]sMDyR[{DsHqV{Soj@mE{LIcCjD_JbDkBhX}Blg@tJ`J|BjEtBbBjGdCtAl@bBZdf@GjNa@`CgAdAyLMCjMuQ[@y@',
  // )

  const latitude = useSelector(getLatiTude)
  const dispatch = useDispatch<Dispatch<any>>()
  const longitude = useSelector(getLongiTude)
  const location = useLocation()
  const navigate = useNavigate()
  const position = [35.7615, 51.30415]
  const fillBlueOptions = { fillColor: 'blue' }
  const [list, setList] = useState('')
  const limeOptions = { color: '#005A9C' }

  const positionLists = useSelector(getPositionLists)
  const mapRef = useRef<any>()


  const filteredData = useMemo(() => {
    return positionLists.filter((p: any) => p.tripId > 0).reduce((acc: any, p: any) => {
        if (!acc[p.tripId]) {
            acc[p.tripId] = [];
        }
        acc[p.tripId].push(p);
        return acc;
    }, {});
  }, [positionLists]);


  const data = useMemo(() => {
    return positionLists.filter((p: any) => p.tripId > 0).map((p: any) => [p.gps.latitude, p.gps.longitude])
  }, [positionLists])

  const speed = useMemo(() => {
    return positionLists.map((p: any) => ({
      position: [p.gps.latitude, p.gps.longitude],
      speed: p.gps.speed,
      date: p.gps.dateTime,
    }))
  }, [positionLists])

  const tripGroups = useMemo(() => {
    const groups: { [key: string]: Array<[number, number, string]> } = {};
    positionLists
      .filter((p: any) => p.tripId > 0)
      .forEach((p: any) => {
        const tripId = p.tripId.toString();
        if (!groups[tripId]) {
          groups[tripId] = [];
        }
        groups[tripId].push([p.gps.latitude, p.gps.longitude, p.gps.dateTime]);
      });
    return groups;
  }, [positionLists]);

  let a1: string | undefined
  let a2: string | undefined
  let b1: string | undefined
  let b2: string | undefined

  if (data.length !== 0) {
    a1 = data[0][0]
    a2 = data[0][1]
    b1 = data[data.length - 1][0]
    b2 = data[data.length - 1][1]
  }

  useEffect(() => {
    return () => {
      dispatch(resetPositionList([]))
    }
  }, [])
  function LoadingMap() {
    const context = useLeafletContext()

    if (data.length !== 0) {
      context.map.flyTo(data[0])
    }

    return null
  }

  const [add2, setAdd2] = useState('')
  const [add3, setAdd3] = useState('')
  // تابع تبدیل نقطه جغرافیایی با آدرس با پلتفرم نشان

  async function getUsers1() {
    try {
      if (a1 === undefined || a2 === undefined) return
      await axios
        .get(`https://api.neshan.org/v5/reverse?lat=${a1}&lng=${a2}`, {
          headers: {
            'Api-Key': 'service.da5f3022ea194c4a97ca9c33cd46efd8',
          },
        })
        .then((response) => {
          setAdd2(response.data.formatted_address)
        })
    } catch (error) {
      if (axios.isAxiosError(error)) {
        return error.message
      } else {
        return 'An unexpected error occurred'
      }
    }
  }
  async function getUsers2() {
    try {
      if (b1 === undefined || b2 === undefined) return
      await axios
        .get(`https://api.neshan.org/v5/reverse?lat=${b1}&lng=${b2}`, {
          headers: {
            'Api-Key': 'service.da5f3022ea194c4a97ca9c33cd46efd8',
          },
        })
        .then((response) => {
          setAdd3(response.data.formatted_address)
        })
    } catch (error) {
      if (axios.isAxiosError(error)) {
        return error.message
      } else {
        return 'An unexpected error occurred'
      }
    }
  }

  void getUsers1()
  void getUsers2()

  // Array of colors to be used for different tripIds
  const colors = ['#1F4690','#0000FF'];
  const [apiResponses, setApiResponses] = useState<{ [key: string]: any }>({});

  useEffect(() => {
    const fetchData = async (lat: any, lon: any, key: any) => {
      try {
        const response = await axios.get(`https://api.neshan.org/v5/reverse?lat=${lat}&lng=${lon}`, {
          headers: {
            'Api-Key': 'service.da5f3022ea194c4a97ca9c33cd46efd8',
          },
          params: { latitude: lat, longitude: lon },
        });
        setApiResponses((prev) => ({
          ...prev,
          [key]: response.data.formatted_address,
        }));
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };

    const fetchTripData = async () => {
      await Promise.all(
        Object.entries(tripGroups).map(async ([tripId, group]) => {
          const [startLat, startLon] = group[0];
          const [endLat, endLon] = group[group.length - 1];
          await fetchData(startLat, startLon, `start-${tripId}`);
          await fetchData(endLat, endLon, `end-${tripId}`);
        })
      );
    };

    fetchTripData().catch(error => console.error('Error in fetchTripData:', error));
  }, [tripGroups]);


  return (
    <Box
      sx={{
        position: 'relative',
        width: '100vw',
        height: '100vh',
        '& .leaflet-popup-content': { fontFamily: 'Vazir' },
      }}
    >
      <MapContainer
        center={data?.length !== 0 ? data[Math.ceil(data.length / 2)] : [35.7219, 51.3347]}
        scrollWheelZoom={false}
        style={{ minHeight: '100%', minWidth: '100%' }}
        whenReady={() => {}}
        zoom={15}
      >
        <TileLayer
          attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
          url='https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png'
        />

        {Object.keys(tripGroups).map((tripId, index) => {
          const group = tripGroups[tripId];
          const start = group[0];
          const end = group[group.length - 1];
          
          return (
            <React.Fragment key={tripId}>
              {/* <Circle center={end} color='red' radius={200} />
              <Circle center={start} color='green' radius={200} /> */}
              <Marker icon={flag} position={[end[0], end[1]]}>
                <Popup>
                  <div>مبدا: {apiResponses[`start-${tripId}`]}</div>
                  <div>{shamsi(start[2])} - {time(start[2])}</div>
                  <div style={{ color: 'blue' }}>مقصد: {apiResponses[`end-${tripId}`]}</div>
                  <div style={{ color: 'blue' }}>{shamsi(end[2])} - {time(end[2])}</div>
                </Popup>
              </Marker>
              <Marker position={[start[0], start[1]]}>
                <Popup>
                  <div style={{ color: 'blue' }}>مبدا: {apiResponses[`start-${tripId}`]}</div>
                  <div style={{ color: 'blue' }}>{shamsi(start[2])} - {time(start[2])}</div>
                  <div>مقصد: {apiResponses[`end-${tripId}`]}</div>
                  <div>{shamsi(end[2])} - {time(end[2])}</div>
                </Popup>
              </Marker>
              <Polyline
                color={colors[index % colors.length]} // Use modulo to cycle through colors
                positions={group.map((p) => [p[0], p[1]])}
                smoothFactor={2}
                weight={10}
              />
            </React.Fragment>
          );
        })}

        {/* }
        {data?.length !== 0 && <Circle center={data[0]} color='green' radius={200} />}
        {data?.length !== 0 && (
          <Marker position={data[0]}>
            <Popup>مبدا: {add2}</Popup>
          </Marker>
        )}
        {data?.length !== 0 && (
          <Marker icon={flag} position={data[data.length - 1]}>
            <Popup>مقصد: {add3}</Popup>
          </Marker>
        )}

        {data?.length !== 0 && <Circle center={data[data.length - 1]} color='red' radius={200} />} */}

        {speed?.map((p: any, i: number) => (
          <Marker icon={icon} key={i} position={p.position}>
            <Popup>
              <Box display='flex' flexDirection='column'>
                <div>سرعت :{p.speed}کیلومتر </div>
                <div>{shamsi(p.date)}:تاریخ</div>
                <div>{time(p.date)}:زمان</div>
              </Box>
            </Popup>
          </Marker>
        ))}

        {Object.keys(tripGroups).map((tripId, index) => (
          <Polyline
            color={colors[index % colors.length]} // Use modulo to cycle through colors
            key={tripId}
            positions={tripGroups[tripId].map((p) => [p[0], p[1]])}
            smoothFactor={2}
            weight={10}
          />
        ))}

        {/* {data?.length !== 0 && (
          <Polyline
            color='#1F4690'
            fillColor='#fff'
            lineJoin='bevel'
            noClip={true}
            positions={data}
            smoothFactor={2}
            weight={10}
          />
        )} */}

        <LoadingMap />
      </MapContainer>
      <IconButton
        onClick={() => navigate(-1)}
        sx={{
          backgroundColor: 'red',
          borderRadius: '50%',
          color: '#fff',
          zIndex: 1501,
          position: 'absolute',
          top: 0,
          right: 0,
          m: 2,
        }}
      >
        <ArrowBackRoundedIcon />
      </IconButton>
    </Box>
  )
}

export default LocationTrip
